import { ISelectItem } from "@/types";
import { ICompany } from "@/types/company";
import { IEmployment } from "@/types/employment";
import {
  IProceed,
  IProceedCreateRequest,
  IProceedRequest,
  IProceedUpdateRequest,
} from "@/types/proceed";
import { Company } from "./company";
import { Employment } from "./employment";

export class Proceed implements IProceed {
  public id = 0;
  public company_id = 0;
  public employment_id = 0;
  public is_member_target = false;
  public per_offer = false;
  public name = "";
  public created_at = "";
  public updated_at = "";

  public employment?: IEmployment | undefined;
  public company?: ICompany | undefined;

  public constructor(props?: IProceed) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
    if (props.employment) {
      this.employment = new Employment(props.employment);
    }

    if (props.company) {
      this.company = new Company(props.company);
    }
  }

  public static toSelectItem(proceed: IProceed): ISelectItem {
    return {
      text: proceed.name,
      value: proceed.id,
    };
  }
}

export class ProceedRequest implements IProceedRequest {
  public id = 0;
  public is_member_target = false;
  public per_offer = false;
  public name = "";
  [key: string]: unknown;

  public constructor(props?: IProceed) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }
}

export class ProceedCreateRequest
  extends ProceedRequest
  implements IProceedCreateRequest {}

export class ProceedUpdateRequest
  extends ProceedRequest
  implements IProceedUpdateRequest {}
